import { FC } from 'react';
import ReactPlayer from 'react-player';

type Props = {
    embedCode: string;
    height?: string;
};

const Video: FC<Props> = ({ embedCode, height = '100%' }) => {
    return (
        <div className="tw-relative tw-h-0 tw-w-[340px] tw-pt-[52.26%] md:tw-w-[724px]">
            <ReactPlayer
                className={'tw-absolute tw-left-0 tw-top-0'}
                url={`https://fast.wistia.net/embed/iframe/${embedCode}`}
                playing={true}
                muted={false}
                width="100%"
                height={height}
                controls={true}
            />
        </div>
    );
};

export default Video;
